/**
 * Barbottina Tiles Animation - Vanilla JavaScript
 */

class BarbottinaTiles {
    constructor() {
        this.tiles = [];
        this.isLoaded = false;
        this.scrollProgress = 0;
        this.init();
    }

    init() {
        // Esperar a que el DOM esté listo
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.setup());
        } else {
            this.setup();
        }
    }

    setup() {
        // Lista de imágenes de mosaicos (solo las que existen)
        const tileImages = [
            'N1.png', 'N2.png', 'N3.png', 'N4.png', 'N5.png', 'N6.png',
            'A1.png', 'A2.png', 'A3.png', 'A4.png', 'A5.png', 'A6.png',
            'D1.png', 'D2.png', 'D3.png', 'D4.png', 'D5.png', 'D6.png',
            'E1.png', 'E2.png', 'E3.png', 'E4.png', 'E5.png', 'E6 .png', // Nota: tiene espacio
            'G1.png', 'G2.png', 'G3.png', 'G4.png', 'G5.png', 'G6.png',
            'M1.png', 'M2.png', 'M3.png', 'M4.png', 'M5.png', 'M6.png',
            'AD1.png', 'AD2.png', 'AD3.png', 'AD4.png', 'AD5 .png', 'AD6.png', // Nota: AD5 tiene espacio
            'AN1.png', 'AN2.png', 'AN3 .png', 'AN4.png', 'AN5.png', 'AN6.png' // Nota: AN3 tiene espacio
        ];

        // Lista de imágenes de patrones hero
        const patternImages = [
            'Group.svg', 'Group10@2x.png', 'Group11.svg', 'Group12.svg', 'Group13.svg',
            'Group14.svg', 'Group15.svg', 'Group16@2x.png', 'Group17@2x.png', 'Group2@2x.png',
            'Group3.svg', 'Group4.svg', 'Group5.svg', 'Group6.svg', 'Group7.svg',
            'Group8.svg', 'Group9.svg', 'orange-bottom.svg', 'Tile.svg', 'Vector.svg',
            'Vector2.svg', 'Vector3.svg', 'Vector4.svg', 'Vector5.svg'
        ];

        // Combinar mosaicos y patrones (asegurar 32 elementos)
        const allImages = [...tileImages, ...patternImages];
        
        // Si no hay suficientes imágenes, repetir las disponibles
        const finalImages = [];
        for (let i = 0; i < 32; i++) {
            finalImages.push(allImages[i % allImages.length]);
        }
        
        // Posiciones fijas y agrupadas centralmente (como Oatside)
        const centerX = window.innerWidth / 2;
        const centerY = window.innerHeight / 2;
        const clusterRadius = 300; // Radio del cluster central
        
        const fixedPositions = [
            // Distribución muy dispersa para aprovechar todo el espacio
            {x: centerX - 400, y: centerY - 300}, {x: centerX - 200, y: centerY - 350}, {x: centerX, y: centerY - 320}, {x: centerX + 200, y: centerY - 340}, {x: centerX + 400, y: centerY - 280},
            {x: centerX - 500, y: centerY - 160}, {x: centerX - 300, y: centerY - 200}, {x: centerX - 100, y: centerY - 120}, {x: centerX + 100, y: centerY - 160}, {x: centerX + 300, y: centerY - 140}, {x: centerX + 500, y: centerY - 180},
            {x: centerX - 400, y: centerY - 40}, {x: centerX - 200, y: centerY}, {x: centerX, y: centerY + 40}, {x: centerX + 200, y: centerY + 20}, {x: centerX + 400, y: centerY + 60},
            {x: centerX - 500, y: centerY + 160}, {x: centerX - 300, y: centerY + 200}, {x: centerX - 100, y: centerY + 160}, {x: centerX + 100, y: centerY + 200}, {x: centerX + 300, y: centerY + 180}, {x: centerX + 500, y: centerY + 220},
            // Elementos en los bordes extremos
            {x: centerX - 600, y: centerY - 200}, {x: centerX + 600, y: centerY - 220}, {x: centerX - 550, y: centerY + 120}, {x: centerX + 550, y: centerY + 140},
            {x: centerX - 400, y: centerY - 450}, {x: centerX + 400, y: centerY - 470}, {x: centerX - 300, y: centerY + 350}, {x: centerX + 300, y: centerY + 370}
        ];
        
        // Crear contenedor principal
        const container = document.getElementById('barbottina-animated-tiles-app');
        if (!container) return;

        container.innerHTML = `
            <div class="relative w-full h-screen overflow-hidden bg-gray-50">
                <!-- Contenedor de mosaicos -->
                <div id="tiles-container" class="absolute inset-0"></div>
            </div>
        `;

        const tilesContainer = document.getElementById('tiles-container');
        
        // Crear mosaicos
        finalImages.forEach((image, index) => {
            const isPattern = patternImages.includes(image);
            
            // Posición inicial fija y dispersa (con verificación de seguridad)
            if (!fixedPositions[index]) {
                console.warn(`No hay posición definida para el índice ${index}`);
                return; // Saltar este tile si no hay posición
            }
            const initialX = fixedPositions[index].x;
            const initialY = fixedPositions[index].y;
            
            // Posición final hacia afuera (más alejada del centro)
            const centerX = window.innerWidth / 2;
            const centerY = window.innerHeight / 2;
            
            // Calcular dirección desde el centro hacia la posición inicial
            const deltaX = initialX - centerX;
            const deltaY = initialY - centerY;
            const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
            
            // Extender la posición hacia afuera creando espacios en blanco (como Oatside)
            const extensionFactor = 3.5; // Factor de extensión mayor para crear más espacios
            const finalX = centerX + (deltaX / distance) * (distance * extensionFactor);
            const finalY = centerY + (deltaY / distance) * (distance * extensionFactor);
            
            // Crear elemento del mosaico
            const tileElement = document.createElement('div');
            tileElement.className = 'absolute w-40 h-40 transition-all duration-500 ease-out';
            tileElement.style.left = `${initialX}px`;
            tileElement.style.top = `${initialY}px`;
            tileElement.style.transform = 'scale(0) rotate(180deg)';
            tileElement.style.opacity = '0';
            tileElement.style.zIndex = '5';
            tileElement.style.filter = 'blur(5px)';
            
            // Crear imagen
            const img = document.createElement('img');
            img.src = `${window.barbottinaData?.templateUrl || ''}/assets/${isPattern ? 'patrones-hero' : 'tiles'}/${image}`;
            img.alt = `${isPattern ? 'Pattern' : 'Tile'} ${index}`;
            img.className = 'w-full h-full object-cover rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300';
            
            if (isPattern) {
                img.style.filter = 'sepia(0.3) saturate(1.2)';
            }
            
            // Manejar error de carga de imagen
            img.onerror = () => {
                tileElement.style.display = 'none';
            };
            
            // Sin efectos hover para evitar superposiciones
            
            tileElement.appendChild(img);
            tilesContainer.appendChild(tileElement);
            
            // Guardar referencia para animación
            this.tiles.push({
                element: tileElement,
                initialX,
                initialY,
                finalX,
                finalY
            });
        });
        
        // Agregar listener de scroll
        this.addScrollListener();
        
        // Iniciar animación de entrada
        this.animateEntrance();
    }

    animateEntrance() {
        // Animar la entrada con fade-in escalonado sutil (como Oatside)
        this.tiles.forEach((tile, index) => {
            setTimeout(() => {
                const element = tile.element;
                element.style.transform = 'scale(1) rotate(0deg)';
                element.style.opacity = '1';
                element.style.filter = 'blur(0px)';
            }, index * 50); // 50ms de delay para un fade-in más suave
        });
    }

    addScrollListener() {
        window.addEventListener('scroll', () => {
            this.updateTilesPosition();
        });
        
        // También actualizar en resize
        window.addEventListener('resize', () => {
            this.updateTilesPosition();
        });
    }

    updateTilesPosition() {
        // Calcular el progreso del scroll (0 a 1)
        const scrollTop = window.pageYOffset;
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;
        const maxScroll = documentHeight - windowHeight;
        
        // Progreso del scroll (0 = inicio, 1 = final)
        this.scrollProgress = Math.min(scrollTop / maxScroll, 1);
        
        // Aplicar animación a cada mosaico
        this.tiles.forEach((tile, index) => {
            const element = tile.element;
            
            // Interpolación suave entre posición inicial (cluster) y final (disperso con espacios)
            const currentX = tile.initialX + (tile.finalX - tile.initialX) * this.scrollProgress;
            const currentY = tile.initialY + (tile.finalY - tile.initialY) * this.scrollProgress;
            
            // Rotación sutil basada en scroll
            const rotation = this.scrollProgress * 45; // Rotación muy sutil (45° máximo)
            
            // Escala que disminuye al dispersarse (creando efecto de "alejamiento")
            const scale = 1 - (this.scrollProgress * 0.15); // Se hacen más pequeños al dispersarse
            
            // Opacidad que disminuye ligeramente al alejarse (como en Oatside)
            const opacity = 1 - (this.scrollProgress * 0.3); // Se vuelven más transparentes al alejarse
            
            // Aplicar transformaciones
            element.style.left = `${currentX}px`;
            element.style.top = `${currentY}px`;
            element.style.transform = `scale(${scale}) rotate(${rotation}deg)`;
            element.style.opacity = opacity;
        });
    }
}

// Inicializar cuando el script se carga
new BarbottinaTiles();
